(function () {

  function initPriceProgress(root) {

    root = root || document;

    const boxes = root.querySelectorAll(
      '[data-price-progress]:not([data-progress-initialized])'
    );

    boxes.forEach(function (box) {

      box.setAttribute('data-progress-initialized', 'true');

      const number = box.querySelector('[data-price-count]');
      const fill = box.querySelector('[data-price-fill]');
      const label = number ? number.closest('strong') : null;
      const bottomText = box.querySelector('.price-progress-bottom');

      if (!number || !fill) return;

      // Unteren Erklärungstext ändern
      if (bottomText) {
        bottomText.textContent =
          'Bei jedem 10. Verkauf steigert sich der Preis um 10%.';
      }

      // Anzeige oben rechts
      function updateLabel(value) {

        if (!label) return;

        if (value === 1) {
          label.textContent = 'Noch 1 Verkauf';
        } else {
          label.textContent = 'Noch ' + value + ' Verkäufe';
        }

      }

      // Zufälliger Endwert zwischen 1 und 6
      const target = Math.floor(Math.random() * 6) + 1;

      let current = 10;

      updateLabel(current);

      fill.style.width = '0%';

      // Kurze Pause nach Öffnen der Produktseite
      setTimeout(function () {

        const timer = setInterval(function () {

          current--;

          updateLabel(current);

          // 10 = 0 %
          // 5 = 50 %
          // 1 = 90 %

          const progress = (10 - current) * 10;

          fill.style.width = progress + '%';

          if (current <= target) {

            clearInterval(timer);

            updateLabel(target);

            fill.style.width =
              ((10 - target) * 10) + '%';

          }

        }, 260);

      }, 900);

    });

  }


  // Normaler Seitenaufruf
  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', function () {
      initPriceProgress(document);
    });

  } else {

    initPriceProgress(document);

  }


  // Shopify Theme Editor
  document.addEventListener('shopify:section:load', function (event) {
    initPriceProgress(event.target);
  });


  // Browser Zurück/Vor
  window.addEventListener('pageshow', function () {
    initPriceProgress(document);
  });

})();